import React__default from 'react';
import { ReviewDisplay } from '@grandvisionhq/reviews';
import { useFeatureToggles } from '@grandvisionhq/state';
import { getReviewsConfigKeys } from './utils/get-reviews-config-keys.js';
import { useProductData } from '../../context/product-context-hooks.js';

const UserReviews = ()=>{
    const { isReviewsEnabled  } = useFeatureToggles();
    const { product , activeVariant: { sku  } ,  } = useProductData();
    if (!isReviewsEnabled) {
        return null;
    }
    const { productId , variantId  } = getReviewsConfigKeys(product, sku);
    return /*#__PURE__*/ React__default.createElement(ReviewDisplay, {
        productId: productId,
        variantId: variantId
    });
};

export { UserReviews };
//# sourceMappingURL=UserReviews.js.map
